'use client'

import styles from './ua.module.scss'
import { useInView } from 'react-intersection-observer';

export default function StickyBar(props) {
  
  const { ref, inView, entry } = useInView({
    threshold: [1],
  });
  
  return <div ref={ref} className={styles.bar + ' ' + props.className + ' ' + styles[props.location] + ' ' + (props.mobile ? 'max-b-xs' : '') + (props.desktop ? 'min-b-xs' : '') + ' ' + (entry?.intersectionRatio < 1 ? props.stickyStyle : '') } aria-hidden="true">
    { props.children }
  </div>
  
}